import { z } from 'zod';

export const revenueCatProduct = z.object({
  object: z.literal('product'),
  id: z.string(),
  // The store bundle (like `com.colt.unlimited.yearly.baseline`)
  store_identifier: z.string(),
  type: z.enum(['subscription', 'one_time', 'consumable', 'non_consumable', 'non_renewing_subscription']),
  subscription: z
    .object({
      /** ISO-8601 Duration (like P1Y) */
      duration: z.string().nullable(),
      /** ISO-8601 Duration (like P1Y) */
      grace_period_duration: z.string().nullable(),
      /** ISO-8601 Duration (like P1Y) */
      trial_duration: z.string().nullable(),
    })
    .nullable(),
  one_time: z
    .object({
      is_consumable: z.boolean().nullable(),
    })
    .nullable(),
  created_at: z.number(),
  app_id: z.string(),
  app: z
    .object({
      object: z.literal('app'),
      id: z.string(),
      name: z.string(),
      created_at: z.number(),
      type: z.enum(['amazon', 'app_store', 'mac_app_store', 'play_store', 'stripe', 'rc_billing', 'roku', 'paddle']),
      project_id: z.string(),
    })
    .passthrough()
    .nullish(),
  display_name: z.string().nullable(),
});

export type RevenueCatProduct = z.infer<typeof revenueCatProduct>;
